import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-save-cancel-buttons',
  templateUrl: './save-cancel-buttons.component.html',
  styleUrls: ['./save-cancel-buttons.component.scss'],
  standalone: false
})
export class SaveCancelButtonsComponent {
  @Input() tabType: 'summary' | 'components' | 'valves' | 'notes' | 'other' = 'other';
  @Input() saveLabel: string = 'Save Changes';
  @Input() cancelLabel: string = 'Cancel';
  @Input() isSaving: boolean = false;
  @Input() disabled: boolean = false;
  @Input() showButtons: boolean = true;

  @Output() saveClicked = new EventEmitter<string>();
  @Output() cancelClicked = new EventEmitter<string>();

  onSave(): void {
    if (!this.disabled && !this.isSaving) {
      this.saveClicked.emit(this.tabType);
    }
  }

  onCancel(): void {
    if (!this.disabled) {
      this.cancelClicked.emit(this.tabType);
    }
  }
}
